<template>
  <Modal title="Доп.поля поиска" @backdrop-click="close">
    <template slot="body">
      <span>Выберите поля для фильтра</span>
      <div class="table-responsive table-responsive_long-list vert-scroll">
        <table class="table">
          <thead>
            <tr>
              <th>
                <input
                  v-focus
                  type="checkbox"
                  :checked="allFieldsWereAdded"
                  @click="handleAllCheckboxes"
                />
              </th>
              <th>Поля</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-if="!addedFieldsSelectors.includes(field.name)"
              v-for="field in fieldsList"
              :key="field.name"
            >
              <td>
                <input
                  type="checkbox"
                  name="operations"
                  :value="field"
                  v-model="choosedFields"
                />
              </td>
              <td>{{ field.title }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div>
          <button
            class="modal-default-button btn btn-default btn-danger buttons__button_close-modal"
            @click="close"
          >
            Закрыть
          </button>
        </div>
        <div>
          <button
            class="modal-default-button btn btn-default left-btn btn-success"
            @click="confirmChoice"
            :disabled="choosedFields.length < 1"
          >
            Выбрать
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { useCheckboxesToggler } from "@/_shared/mixins";
import Modal from "@/_shared/components/ui/Modal";
export default {
  mixins: [useCheckboxesToggler],
  components: {
    Modal,
  },
  props: {
    fieldsList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  mounted() {
    document.querySelector("body").style.overflow = "hidden";
  },
};
</script>

<style scoped>
table {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/modals/CustomFieldsModal.vue